export default __webpack_public_path__ + "static/media/Version (6) - Ultimate Map_11.cb5f6acf.jpg";